<div class="loader-container">
  <svg class="spinner color-{{ color }} size-{{ size }} speed-{{ speed }} stroke-{{ stroke }}" viewBox="0 0 48 48">
    <circle class="path" cx="24" cy="24" r="20" fill="none"></circle>
  </svg>
</div>
